import React, { useRef } from "react";
import { IconButton, Tooltip } from "@material-ui/core";
import { Delete } from "@material-ui/icons";
import { ConfirmDelete } from "../../../../components";

const Trash = (props) => {
  const { custodian, archiveCustodian } = props;

  const confirmDeleteRef = useRef();

  return (
    <ConfirmDelete
      dialogTitle="Confirm"
      dialogText="Are you sure you want to delete this custodian?"
      dialogConfirmedCallback={() => archiveCustodian(custodian)}
      ref={confirmDeleteRef}
    >
      <Tooltip title="Delete" placement="right">
        <IconButton
          aria-label="delete"
          size="small"
          onClick={() => confirmDeleteRef.current.handleModalOpen()}
        >
          <Delete />
        </IconButton>
      </Tooltip>
    </ConfirmDelete>
  );
};

export default Trash;



// WEBPACK FOOTER //
// ./src/containers/AdminCustodianList/components/Trash/index.jsx